export default [
	{
		id: "allMeasures",
		title: "All measures"
	},
	{
		id: "Positive change",
		title: "Positive change"
	},
	{
		id: "Negative change",
		title: "Negative change"
	},
	{
		id: "No change",
		title: "No change"
	},
	{
		id: "Change not assessed",
		title: "Change not assessed"
	}
]